import RewardService from "@/services/partners/Reward.service";
import { 
  DEFAULT_PAGINATION_REWARD_DETAIL,
  DEFAULT_REWARD_DETAIL,
  RewardState,
} from ".";
import {
  __GetBadgeCount,
  __GetExcelReward, __GetExcelRewardDetailPayload,
  __GetRewardDetailPayload,
  __GetRewards,
  __UpdateStatusRewards,
} from './action-dto'

/* library toast */
import "vue3-toastify/dist/index.css";

/* Service */
import ToastService from "@/services/Toast.service";

export default {
  GET_REWARDS(state: RewardState, payload: __GetRewards) {    
    state.is_loading_rewards = true;
    state.is_error_rewards = null;

    RewardService.getRewards(payload)
      .then((res) => {
        state.is_error_rewards = null;
        state.rewards = res.data;
        if (res.pagination) state.pagination = { ...res.pagination };
      })
      .catch((err) => {
        state.is_error_rewards = "Found an error.";
      })
      .finally(() => {
        state.is_loading_rewards = false;
      });
  },
  GET_WAIT_FOR_REQUEST_COUNT(state: RewardState, payload: __GetBadgeCount) {
    RewardService.getBadgeCount({ ...payload, status: "Request" })
      .then((res) => {
        state.is_error_rewards = null;
        state.wait_for_request_count = res.data;
      })
      .catch((err) => {
        state.wait_for_request_count = 0;
      });
  },

  GET_PENDING_COUNT(state: RewardState, payload: __GetBadgeCount) {
    RewardService.getBadgeCount({ ...payload, status: "Pending" })
      .then((res) => {
        state.is_error_rewards = null;
        state.pending_count = res.data;
      })
      .catch((err) => {
        state.pending_count = 0;
      });
  },

  UPDATE_STATUS_REWARDS(state: RewardState, payload: __UpdateStatusRewards) {
    RewardService.updateStatusRewards({ ...payload, status: "Pending" })
      .then((res) => {
        state.is_error_rewards = null;
      })
      .catch((err) => {
        return;
      });
  },

  GET_EXCEL_REWARD(state: RewardState, payload: __GetExcelReward) {
    RewardService.getExcelReward(payload)
      .then((res) => {
        const data = res.data as any; // as any for excel
        const blob = new Blob([data], { type: res.headers["content-type"] });
        const url = window.URL.createObjectURL(blob);
        const fileName =
          "Affiliate_result_export_as_of_" +
          payload.dateStart +
          "-" +
          payload.dateEnd +
          ".xlsx";
        const a = document.createElement("a");
        document.body.appendChild(a);
        a.href = url;
        a.download = fileName;
        a.click();
        window.URL.revokeObjectURL(url);
      })
      .catch((err) => {
        return ToastService.showWarning("Downloading excel file error");
      });
  },
  
  GET_REWARD_DETAIL(state: RewardState, payload: __GetRewardDetailPayload) {
    state.is_loading_reward_detail = true;
    state.is_error_reward_detail = false;

    RewardService.getRewardDetail(payload)
      .then((res) => {
        state.is_error_reward_detail = false;
        state.reward_detail = res.data;
        state.pagination_reward_detail =
          res.pagination || state.pagination_reward_detail;
      })
      .catch((err) => {
        state.is_error_reward_detail = true;
        state.reward_detail = DEFAULT_REWARD_DETAIL;
        state.pagination_reward_detail = DEFAULT_PAGINATION_REWARD_DETAIL;
      })
      .finally(() => {
        state.is_loading_reward_detail = false;
      });
  },
  GET_EXCEL_REWARD_DETAIL(state: RewardState, payload: __GetExcelRewardDetailPayload) {
    RewardService.getExcelRewardDetail(payload)
      .then((res) => {
        const data = res.data as any; // as any for excel
        const blob = new Blob([data], { type: res.headers["content-type"] });
        const url = window.URL.createObjectURL(blob);
        const fileName = "Affiliate_reward_detail_report.xlsx"
        const a = document.createElement("a");
        document.body.appendChild(a);
        a.href = url;
        a.download = fileName;
        a.click();
        window.URL.revokeObjectURL(url);
      })
      .catch((err) => {
        return ToastService.showWarning("Downloading excel file error!");
      });
  },
  RESET_REWARD_DETAIL(state: RewardState) {
    state.reward_detail = DEFAULT_REWARD_DETAIL;
    state.pagination_reward_detail = DEFAULT_PAGINATION_REWARD_DETAIL;
  }
};
